'use client';

// import mock data
import { _offices } from 'src/data/offices';
import { useLocale } from 'src/locales/localization-provider';

import { BackToTopButton } from 'src/components/animate/back-to-top-button';
import { ScrollProgress, useScrollProgress } from 'src/components/animate/scroll-progress';

import { AboutOverView } from '../about-overview';
import { VisionAndMission } from '../vision-and-mision';
import { Clients } from 'src/sections/_home/clients';
import { DownloadApp } from 'src/sections/_home/download-app';
import { brands } from 'src/components/carousel/utils';
import { WhoWeAre } from 'src/sections/_home/who-we-are';
import { AboutLeadership } from '../about-leadership';
import { AboutCommitment } from '../about-commitment';
import { AboutSustainability } from '../about-sustainability';

// ----------------------------------------------------------------------

export function AboutUsView() {
  const pageProgress = useScrollProgress();
  const { t } = useLocale();

  return (
    <>
      <ScrollProgress
        variant="linear"
        progress={pageProgress.scrollYProgress}
        sx={{ position: 'fixed' }}
      />
      <BackToTopButton />
      {/* <ContactBaner /> */}
      {/* ✅ Passing mock data */}
      <AboutOverView />
      {/* <WhoWeAre /> */}
      <AboutLeadership />

      {/* <VisionAndMission /> */}
      <AboutCommitment />
      <AboutSustainability />

      {/* <Clients brands={brands} /> */}
      {/* <DownloadApp /> */}
    </>
  );
}
